var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4714 4.47145C10.7318 4.2111 10.7318 3.78899 10.4714 3.52864C10.2111 3.26829 9.78897 3.26829 9.52862 3.52864L5.52862 7.52864C5.26827 7.78899 5.26827 8.2111 5.52862 8.47144L9.52862 12.4714C9.78897 12.7318 10.2111 12.7318 10.4714 12.4714C10.7318 12.2111 10.7318 11.789 10.4714 11.5286L6.94283 8.00004L10.4714 4.47145Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.ebd96c145b00f7684789fc4374c0835b.svg";
export { ForwardRef as ReactComponent };